module.exports = "pegasus_template/assets/email1-image-3.png";